module.exports = "/wp-content/themes/conversion/public/dist//svgs/conversion-logo-white.svg";